import orderBy from 'lodash/orderBy'
import { MembershipFeesQueryType } from '../../../../types'
import {
  BorderlessAccordion,
  CellProps,
  createKeysAndColumnNameArray,
  DenseTable,
  TableType,
  TitledSection
} from '../../../../components'
import { MembershipFeeAccrualBasesRow } from '../types'
import { groupAccrualBases } from '../utils'

interface AccrualBasesProps {
  membershipFees: MembershipFeesQueryType
}

export const AccrualBases = ({ membershipFees }: AccrualBasesProps) => {
  const groupedAccrualBases = groupAccrualBases(membershipFees)

  // Sort grouped years (desc)
  const orderedAccrualBasesByYear = orderBy(
    Object.keys(groupedAccrualBases),
    [],
    ['desc']
  )

  const keysETC: CellProps<MembershipFeeAccrualBasesRow>[] =
    createKeysAndColumnNameArray(
      'pages.membershipFeesPage.calculateMembershipFeePage.',
      [
        {
          key: 'maksujakso',
          translationIdPostfix: 'paymentPeriod',
          displayWhenNull: '-'
        },
        {
          key: 'maksuperuste',
          translationIdPostfix: 'accrualBase',
          displayWhenNull: '-'
        }
      ]
    )

  return (
    <TitledSection
      addTopPadding={false}
      translationid="pages.membershipFeesPage.calculateMembershipFeePage.accrualBases"
    >
      {orderedAccrualBasesByYear.map((year, index) => {
        return (
          <BorderlessAccordion
            key={'accordion-' + year}
            title={`${year} (${groupedAccrualBases[year].length})`}
            defaultExpanded={!index}
          >
            <DenseTable
              key={'accordion-table-' + year}
              type={TableType.Static}
              cellProps={keysETC}
              data={groupedAccrualBases[year]}
              tableStylingProps={{ addBorderToFirstMobileColumnBox: true }}
            />
          </BorderlessAccordion>
        )
      })}
    </TitledSection>
  )
}
